import {
  Button,
  DialogContent,
  DialogTitle,
  Modal,
  ModalClose,
  ModalDialog,
  DialogActions,
  Stack,
} from "@mui/joy";
import { useTranslation } from "../../../i18n";
import { useInspectionCreateDraftWithSkUsMutation } from "../../../__generated__/types-and-hooks";
import { useCallback, useEffect, useState } from "react";
import { useTeam } from "../TeamLayout";
import { useNotify } from "../../../hooks/useNotify";
import QSelect from "../../../x-components/QSelect";
import { useServiceTypeOptions } from "./hooks/useServiceTypeOptions";
import QDatePicker from "../../../x-components/QDatePicker";
import { addDays } from "date-fns";

export interface InspectionAddModalProps {
  open: boolean;
  onClose: () => void;
}

class Inspection {
  public serviceType: string = "PSI";
  public startDate: Date = addDays(new Date(), 10);
  public inspectionLots = [];

  constructor(public brandId: number) {}
}

export default function InspectionAddModal({
  open,
  onClose,
}: InspectionAddModalProps) {
  const teamCtx = useTeam();
  const [inspection, setInspection] = useState(new Inspection(teamCtx.team.id));

  useEffect(() => {
    setInspection(new Inspection(teamCtx.team.id));
  }, [open, teamCtx.team]);

  const t = useTranslation();
  const [createDraftInspection, { loading }] =
    useInspectionCreateDraftWithSkUsMutation();

  const [saving, setSaving] = useState(false);
  const notify = useNotify();

  const serviceTypeOptions = useServiceTypeOptions();

  const handleSave = useCallback(async () => {
    setSaving(true);
    await createDraftInspection({
      variables: {
        draft: inspection,
      },
      onCompleted(inspection) {
        notify({
          type: "success",
          msg: `Inspection ${inspection.inspection_create_draft.uniqueId} booked`,
        });
        onClose();
      },
    });
    setSaving(false);
  }, [createDraftInspection, inspection, notify, onClose]);

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog size="md" variant="outlined">
        <ModalClose />
        <DialogTitle>{t("New Inspection")}</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <QSelect
              label={t("Service Type")}
              val={serviceTypeOptions[0].value}
              options={serviceTypeOptions}
              update={async (serviceType) => {
                setInspection(Object.assign({}, inspection, { serviceType }));
                return serviceType;
              }}
            />
            <QDatePicker
              label={t("Service Date Start")}
              val={inspection.startDate}
              update={async (startDate) => {
                setInspection(Object.assign({}, inspection, { startDate }));
                return startDate?.toString();
              }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            fullWidth
            onClick={handleSave}
            disabled={saving}
            loading={loading}
          >
            {t("Save")}
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
}
